import { BaseExtension } from '../extensions';
export class BaseInstrumentation extends BaseExtension {
    constructor() {
        super(...arguments);
        this.api = {};
        this.transports = {};
    }
}
